import { PaletteOptions } from "@mui/material";

declare module "@mui/material/styles" {
  interface TypeBackground {
    gradientDark: string;
    gradient: string;
  }
}

export const MAIN_PALETTE = {
  mode: "dark",
  background: {
    default: "#000000",
    paper: "#1F1F1F",
    gradientDark: "linear-gradient(180deg, #200D2F 0%, #1C0E11 100%)",
    gradient: "linear-gradient(133deg, #FFD839 -26%, #FF81F7 99%)",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
  divider: "rgba(255, 255, 255, 0.1)",
  text: {
    primary: "#FFFFFF",
    secondary: "#8C8C8C",
  },
  primary: {
    main: "#9E95D9",
  },
  secondary: {
    main: "#FaD81C",
  },
  info: {
    main: "#5465FF",
  },
  warning: {
    main: "#FF5C00",
  },
  error: {
    main: "#FF5252",
  },
  success: {
    main: "#38D075",
  },
  grey: {
    "100": "#8C8C8C",
    "400": "#3D3D3D",
    "500": "#333333",
    "700": "#212121",
  },
} satisfies PaletteOptions;
